









import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import dialogComp from "@/components/dialog/index.vue";
import { Button } from "mint-ui";

@Component<VBANNER>({
  components: {
    dialogComp,
    "mt-button": Button,
  },
})
export default class VBANNER extends Vue {
  public tipType:number = 0;/* 0是已参与过活动，1是未中奖 */
  public tipError:string = '';
  public giftTip:string = '';
  public show() {
    (this.$refs.dialog as any).show();
  }
  public goAppoint(){
    this.close();
    let timer = setTimeout(()=>{
        clearTimeout(timer);
        timer = 0;
        window.scrollTo(0,(document as any).querySelector('#appoint').offsetTop)
    },600)
  }
  public close() {
    (this.$refs.dialog as any).close();
  }
}
